// Patches Bootstrap Alert._destroyElement for Turbo + fade race.
//
// Alert.close() starts a fade transition; Turbo Drive / turbo_stream.replace('flash')
// may remove/dispose the node before transitionend. BaseComponent#dispose() nulls
// `_element`, then `_destroyElement` crashes:
//
//   this._element.remove()
//   TypeError: Cannot read properties of null (reading 'remove')
//
// See: TSHMANAGERWEB-HW. Same class of race as bootstrap_modal_safety.js /
// bootstrap_tooltip_safety.js.
import { Alert } from "bootstrap"

const originalDestroyElement = Alert.prototype._destroyElement

Alert.prototype._destroyElement = function patchedDestroyElement() {
  if (!this._element) {
    return
  }

  return originalDestroyElement.call(this)
}
